export const USER_DATA = 'autentica_user_data';